module.exports = __webpack_public_path__ + "static/img/call-pass.00e0bf71.png";